import $api from "@/api/ResumeModule";
//实现时间戳转化时间

export function formatDate(date, fmt) {
  if (date.getFullYear() === 1970) {
    return "无记录";
  } else {
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        (date.getFullYear() + "").substr(4 - RegExp.$1.length)
      );
    }
    let o = {
      "M+": date.getMonth() + 1,
      "d+": date.getDate(),
      "h+": date.getHours(),
      "m+": date.getMinutes(),
      "s+": date.getSeconds()
    };
    for (let k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        let str = o[k] + "";
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1 ? str : padLeftZero(str)
        );
      }
    }
    return fmt;
  }
}

function padLeftZero(str) {
  return ("00" + str).substr(str.length);
}
// 手机号验证
export const checkPhone = (rule, value, callback) => {
  const phoneReg = /^((\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$)$/;
  if (!value) {
    return callback(new Error("电话号码不能为空"));
  }
  setTimeout(() => {
    if (phoneReg.test(value)) {
      callback();
    } else {
      callback(new Error("电话号码格式不正确"));
    }
  }, 100);
};
/**
 * 时间转时间戳
 * @param {*} str  字符串
 * @param {*} len  获得长度
 */
export const toTimestamp = (str, len = 10) => {
  str = str.match(/\d+/g);
  str = "{0}/{1}/{2} {3}:{4}:{5}".replace(/\{(\d+)\}/g, (_, n) => {
    let item = str[n] || "0";
    item.length < 2 ? (item = "0" + item) : null;
    return item;
  });
  return Number(String(new Date(str).getTime()).substring(0, len));
};



// WEBPACK FOOTER //
// ./src/assets/js/public.js